<template>
  <div class="lc-date-range-search">
    <span class="quicktime-search">{{ label }}</span>
    <lc-date-range-picker v-model="dateRange" clearable class="date-range-picker" @change="handleDateRangeChange"></lc-date-range-picker>
  </div>
</template>

<script>
import { ApiSearching } from '@/constants/bus_event'
import SearchMixin from '@/mixins/search'
import FilterMixin from '@/mixins/filter' // 日期的处理

export default {
  name: 'LcDateRangePickerSearch',
  mixins: [SearchMixin, FilterMixin],
  props: {
    /**
     * 通讯的总线
     */
    bus: {
      type: Object,
      default: () => null
    },
    // 筛选使用的参数名
    paramKey: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: '创建日期'
    }
  },
  data() {
    return {
      dateRange: null,
      isClickEvent: true
    }
  },
  created() {
    // Api 搜索启动后，响应（除了响应的方法，其他的基本已经不需要）
    if (this.bus) this.bus.$on(ApiSearching, this._apiSearchingProcess)
  },
  destroyed() {
    if (this.bus) this.bus.$off(ApiSearching, this._apiSearchingProcess)
  },
  methods: {
    /**
     * API 搜索的同步
     *
     * @param {object} search 搜索信息
     * @param {object} search.pagination 分页信息
     *   格式：{page, perPage}
     */
    _apiSearchingProcess({ params, updatedParamsKeys }) {
      if (this.paramKey && updatedParamsKeys.includes(this.paramKey)) {
        // this.isClickEvent = false // 非人工点击的，不触发查询

        // 更新到 picker
        this.dateRange = this.parseApiParam2DateRangePicker(params[this.paramKey])
      }
    },
    handleDateRangeChange(dateRange) {
      this.emitApiDateRangeParam(this.bus, this.paramKey, this.dateRangePicker2ApiParam(dateRange), { isClick: true }) // 主动通过 bus 向 datasource 沟通变化
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-date-range-search {
  display: inline-block;
}
.el-date-editor {
  border-radius: 0px 5px 5px 0px;
}
::v-deep .el-range-editor--small .el-range-separator {
  padding-left: 0px;
}
.quicktime-search {
  display: inline-block;
  padding: 7px 10px;
  border-radius: 5px 0px 0px 5px;
  height: 32px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  font-size: 12px;
  vertical-align: bottom;
  color: #ffffff;
}
.date-range-picker {
  width: 250px !important;
}
</style>
